export default "__VITE_ASSET__CltUKIHz__"